var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "talkArea",
      staticClass: "yxtbiz-ai-create-ques-ai",
      class: {
        "yxtbiz-ai-create-ques-ai--mode1": this.askingType === 1,
        "yxtbiz-ai-create-ques-ai--mode2": this.askingType === 2,
      },
    },
    [
      _c(
        "div",
        { staticClass: "yxtbiz-ai-create-ques__point-panel" },
        [
          _c(
            "ai-textarea",
            {
              ref: "txtAsk",
              attrs: {
                maxlength: "5000",
                subDisabled: _vm.asking,
                placeholder: _vm.$t(
                  "pc_biz_ote_lbl_aigetpointstip" /** 输入或粘贴已有文档内容，AI将分析内容生成重要知识点 */
                ),
                btnText: _vm.$t("pc_biz_ote_btn_getpoints" /** 提取知识点 */),
                canSave: !!_vm.selectedKngInfo,
                subTip: _vm.selectedKngInfo && _vm.selectedKngInfo.title,
                canBlur: !_vm.showSelectPanel || !!_vm.selectedKngInfo,
                disabled: !_vm.hasAIBalances,
              },
              on: {
                save: function ($event) {
                  return _vm.askAI(1, true)
                },
                focus: function ($event) {
                  _vm.inputing = true
                },
                blur: function ($event) {
                  _vm.inputing = false
                },
                subFocus: function ($event) {
                  return _vm.changeSubInput(1)
                },
                subBlur: function ($event) {
                  return _vm.changeSubInput(0)
                },
              },
              model: {
                value: _vm.askInfo,
                callback: function ($$v) {
                  _vm.askInfo = $$v
                },
                expression: "askInfo",
              },
            },
            [
              _c("template", { slot: "subinfo" }, [
                !_vm.selectedKngInfo
                  ? _c(
                      "div",
                      { staticClass: "yxtbiz-ai-create-ques__select-file" },
                      [
                        _c(
                          "div",
                          { staticClass: "color-gray-7 text-center mb8" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_biz_ote_btn_selectkngtips"
                                ) /** 你还可以选择文件生成知识点和试题 */
                              )
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "flex flex-mid flex-center" },
                          [
                            _c(
                              "yxt-button",
                              {
                                staticClass:
                                  "yxtbiz-ai-create-ques__select-file-btn",
                                attrs: { type: "text3" },
                                on: {
                                  click: function ($event) {
                                    return _vm.startSelectKng()
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-mid" },
                                  [
                                    _c("yxt-svg", {
                                      staticClass: "color-gray-10",
                                      attrs: {
                                        "remote-url": _vm.SvgMediaNewUrl,
                                        width: "20px",
                                        height: "20px",
                                        "icon-class": "ai-kng-2",
                                      },
                                    }),
                                    _c("div", { staticClass: "ml4" }, [
                                      _c(
                                        "div",
                                        { staticClass: "color-gray-10" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pc_biz_ote_btn_selectkng"
                                                ) /** 选择课程 */
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _c(
                              "yxt-button",
                              {
                                staticClass:
                                  "yxtbiz-ai-create-ques__select-file-btn",
                                attrs: { type: "text3" },
                                on: {
                                  click: function ($event) {
                                    return _vm.startSelectKngLib()
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-mid" },
                                  [
                                    _c("yxt-svg", {
                                      staticClass: "color-gray-10",
                                      attrs: {
                                        "remote-url": _vm.SvgMediaNewUrl,
                                        width: "20px",
                                        height: "20px",
                                        "icon-class": "ai-kng-lib2",
                                      },
                                    }),
                                    _c("div", { staticClass: "ml4" }, [
                                      _c(
                                        "div",
                                        { staticClass: "color-gray-10" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pc_biz_ote_btn_selectknglib"
                                                ) /** 选择知识 */
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _c(
                      "div",
                      { staticClass: "yxtbiz-ai-create-ques__selected-file" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-mid flex-shrink-1 yxtbiz-ote-ai-over-hidden",
                          },
                          [
                            _c("yxt-svg", {
                              staticClass: "flex-shrink-0 mr6",
                              attrs: {
                                width: "20px",
                                height: "20px",
                                "remote-url": _vm.kngFileTypeIconUrl,
                                "icon-class": _vm.getKngFileTypeIcon(
                                  _vm.selectedKngInfo.fileType
                                ),
                              },
                            }),
                            _c(
                              "yxt-tooltip",
                              {
                                attrs: {
                                  content: _vm.selectedKngInfo.title,
                                  "open-filter": "",
                                  placement: "top",
                                },
                              },
                              [
                                _c("div", { staticClass: "ellipsis mr4" }, [
                                  _vm._v(_vm._s(_vm.selectedKngInfo.title)),
                                ]),
                              ]
                            ),
                            _vm.selectedKngInfo.errorInfo
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex-shrink-0 flex flex-mid color-gray-7 ml12 yxtbiz-ai-create-ques__selected-file-error",
                                  },
                                  [
                                    _c("yxt-svg", {
                                      staticClass: "mr4",
                                      attrs: {
                                        width: "16px",
                                        height: "16px",
                                        "icon-class": "message-error",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.clearKngInfo.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.selectedKngInfo.errorInfo) +
                                        "\n            "
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "yxtbiz-ote-ai-icon ml8 hand",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.clearKngInfo.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("yxt-svg", {
                              attrs: {
                                width: "16px",
                                height: "16px",
                                "icon-class": "delete",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
              ]),
              _vm.currentTalkPointInfo || (_vm.asking && _vm.askingType === 1)
                ? _c(
                    "template",
                    { slot: "contentSub" },
                    [
                      _vm.asking && _vm.askingType === 1
                        ? [
                            _c(
                              "yxt-button",
                              {
                                attrs: { type: "text3" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cancelAsk()
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "flex flex-mid" },
                                  [
                                    _c("yxt-svg", {
                                      staticClass: "mr4",
                                      attrs: {
                                        "remote-url": _vm.SvgMediaNewUrl,
                                        width: "16px",
                                        height: "16px",
                                        "icon-class": "ai-stop-cc",
                                      },
                                    }),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("pc_biz_stop" /** 停止 */)
                                        ) +
                                        "\n            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        : [
                            _c(
                              "div",
                              {
                                staticClass: "yxtbiz-ote-ai-icon color-gray-7",
                                class: {
                                  "yxtbiz-ote-ai-icon--disabled":
                                    _vm.askIndexHistoryIndex <= 0,
                                },
                              },
                              [
                                _c("yxt-svg", {
                                  attrs: {
                                    width: "16px",
                                    height: "16px",
                                    "icon-class": "arrow_left",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.changeAskIndexHistoryIndex(-1)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("span", { staticClass: "mh4 minw24" }, [
                              _vm._v(
                                _vm._s(_vm.askIndexHistoryIndex + 1) +
                                  "/" +
                                  _vm._s(_vm.currentAskPointsList.length)
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "yxtbiz-ote-ai-icon color-gray-7",
                                class: {
                                  "yxtbiz-ote-ai-icon--disabled":
                                    _vm.askIndexHistoryIndex >=
                                    _vm.currentAskPointsList.length - 1,
                                },
                              },
                              [
                                _c("yxt-svg", {
                                  attrs: {
                                    width: "16px",
                                    height: "16px",
                                    "icon-class": "arrow_right",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.changeAskIndexHistoryIndex(1)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
              _vm.currentTalkPointInfo
                ? _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      { ref: "refPoints" },
                      [
                        _c("div", { staticClass: "mb12" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "pc_biz_ote_lbl_aipointstip" /** 以下是为你提取的重要知识点，请根据需要选 */
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                        _c(
                          "yxt-checkbox-group",
                          {
                            attrs: { direction: "row" },
                            model: {
                              value: _vm.currentTalkPointInfo.checkedPoints,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.currentTalkPointInfo,
                                  "checkedPoints",
                                  $$v
                                )
                              },
                              expression: "currentTalkPointInfo.checkedPoints",
                            },
                          },
                          [
                            _c(
                              "transition-group",
                              {
                                key: _vm.currentTalkPointInfo.talkId,
                                attrs: { name: "yxt-fade-in-linear" },
                              },
                              _vm._l(
                                _vm.currentTalkPointInfo.allPoints,
                                function (p) {
                                  return _c(
                                    "yxt-checkbox",
                                    { key: p.point, attrs: { label: p.point } },
                                    [_vm._v(_vm._s(p.point))]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.answering
                          ? _c("div", [
                              _c("div", { staticClass: "flex" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "pc_biz_ai_thinking"
                                      ) /** 正在思考 */
                                    ) +
                                    "\n              "
                                ),
                                _c(
                                  "div",
                                  { staticClass: "ml8 yxtbiz-thinking-dot" },
                                  [_c("div"), _c("div"), _c("div")]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm.askingType === 1 && _vm.asking
                ? _c("template", { slot: "content" }, [
                    _vm.parsing && _vm.selectedKngInfo
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-vertical flex-center flex-mid",
                          },
                          [
                            _c("yxt-svg", {
                              staticClass: "flex-shrink-0 mb8",
                              attrs: {
                                width: "40px",
                                height: "40px",
                                "remote-url": _vm.kngFileTypeIconUrl,
                                "icon-class": _vm.getKngFileTypeIcon(
                                  _vm.selectedKngInfo.fileType
                                ),
                              },
                            }),
                            _c(
                              "div",
                              { staticClass: "d-in-flex flex-mid mb20" },
                              [
                                _c("div", {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: true,
                                      expression: "true",
                                    },
                                  ],
                                  attrs: {
                                    "yxt-loading-custom-class":
                                      "yxtbiz-ai-create-ques-loading",
                                    "yxt-loading-size": "small",
                                  },
                                }),
                                _c("div", { staticClass: "color-gray-10" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "pc_biz_ote_msg_parsing" /** 解析中，时间可能较长，请耐心等待 */
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "yxt-button",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.cancelAsk()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("pc_biz_ote_btn_cancle") /** 取消 */
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm.answering
                      ? _c("div", [
                          _c("div", { staticClass: "flex" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("pc_biz_ai_thinking") /** 正在思考 */
                                ) +
                                "\n            "
                            ),
                            _c(
                              "div",
                              { staticClass: "ml8 yxtbiz-thinking-dot" },
                              [_c("div"), _c("div"), _c("div")]
                            ),
                          ]),
                        ])
                      : _c("div"),
                  ])
                : _vm._e(),
              _vm.currentTalkPointInfo && !_vm.asking
                ? _c(
                    "div",
                    {
                      staticClass: "color-gray-7 standard-size-12",
                      attrs: { slot: "contentBottomSub" },
                      slot: "contentBottomSub",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "pc_biz_ote_msg_instructionsforaiquestip" /** 注：受限于AI模型，偶有AI返回的数据不完整，请自行核对生成的试题是否正确 */
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.currentTalkPointInfo && !_vm.asking
                ? _c(
                    "template",
                    { slot: "contentBottom" },
                    [
                      _c(
                        "yxt-button",
                        {
                          attrs: { type: "text3" },
                          on: {
                            click: function ($event) {
                              return _vm.askAI(1)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "flex flex-mid" },
                            [
                              _c("yxt-svg", {
                                staticClass: "mr4",
                                attrs: {
                                  width: "16px",
                                  height: "16px",
                                  "icon-class": "right-rotate",
                                },
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("pc_biz_ai_reanswer" /** 重新回答 */)
                                  ) +
                                  "\n          "
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "yxt-button",
                        {
                          attrs: { type: "text3" },
                          on: {
                            click: function ($event) {
                              return _vm.backAsk(1)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "flex flex-mid" },
                            [
                              _c("yxt-svg", {
                                staticClass: "mr4",
                                attrs: {
                                  width: "16px",
                                  height: "16px",
                                  "icon-class": "delete",
                                },
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "pc_biz_ote_btn_deprecate" /** 弃用 */
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c("div", [
            _c(
              "div",
              { staticClass: "mt8 yxtbiz-ote-num-input-group" },
              _vm._l(_vm.quesGenTypeCount, function (c, type) {
                return _c("number-input", {
                  key: type,
                  staticClass: "yxtbiz-ote-num-input",
                  attrs: {
                    name: _vm.$t(_vm.QUES_TYPE_NAMES[type]),
                    maxTip: _vm.$t(
                      "pc_biz_ote_msg_aiquesmaxcounttip" /** 每次最多生成10题 */,
                      [10]
                    ),
                  },
                  model: {
                    value: _vm.quesGenTypeCount[type],
                    callback: function ($$v) {
                      _vm.$set(_vm.quesGenTypeCount, type, $$v)
                    },
                    expression: "quesGenTypeCount[type]",
                  },
                })
              }),
              1
            ),
            _c(
              "div",
              { staticClass: "flex mt16" },
              [
                _vm.beforeQuesTalkId
                  ? _c(
                      "yxt-tooltip",
                      {
                        attrs: {
                          content: _vm.$t(
                            "pc_biz_ote_msg_viewaskedquestions" /** 查看已生成的试题 */
                          ),
                          placement: "top",
                          disabled: _vm.asking || _vm.askingType === 2,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "yxtbiz-ai-talking__btns yxtbiz-ai-talking__btns--circle mr16 height40",
                            class: {
                              "yxtbiz-ai-talking__btns--disabled": _vm.asking,
                            },
                            on: {
                              click: function ($event) {
                                !_vm.asking && _vm.goAskedQues()
                              },
                            },
                          },
                          [
                            _c("yxt-svg", {
                              attrs: {
                                width: "24px",
                                height: "24px",
                                "icon-class": "bars",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "yxt-tooltip",
                  {
                    attrs: {
                      content: _vm.$t(
                        !_vm.hasAIBalances
                          ? "pc_biz_ote_msg_aiquesnobalancetip" /** 剩余可用出题题数不足，请联系管理员 */
                          : "pc_biz_ote_msg_aiquesquitedittip" /** 请先退出内容修改或者点击生成知识点 */
                      ),
                      placement: "top",
                      disabled: !_vm.askInfoEditing && _vm.hasAIBalances,
                    },
                  },
                  [
                    _c(
                      "yxt-button",
                      {
                        staticClass: "yxtbiz-ai-create-ques-btn flex-g-1",
                        attrs: {
                          type: "primary",
                          size: "large",
                          disabled:
                            !_vm.isCanGenQues ||
                            !_vm.hasAIBalances ||
                            !_vm.hasGenQuesNum,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.askAI(2)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("pc_biz_ote_btn_genques" /** 生成试题 */)
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "mt12 color-gray-7 standard-size-12 text-center" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("pc_biz_ote_msg_tiptag", [
                        _vm.$t(
                          "pc_biz_ote_msg_aiquescounttip" /** 注：每次最多生成10题，生成试题将消耗出题数量 */,
                          [10]
                        ),
                      ])
                    ) +
                    "\n      "
                ),
              ]
            ),
          ]),
          _c("yxtbiz-select-kng", {
            ref: "selectKng",
            attrs: {
              maxNum: 1,
              includeTypes: [1, 2, 3],
              openPage: _vm.openKngPage,
              isOpenUpload: false,
              IsBuyCourseMenu: false,
              pmType: 2,
              isAi: true,
              env: 1,
              zip: false,
              isKngMenu: false,
              isCreateTime: "",
              excludeFileType: true,
              isNoNeedAuth: false,
              canSelectLibKng: false,
              sourceType: 1,
              beforeKng: _vm.selectedKng ? [_vm.selectedKng] : [],
            },
            on: { getKngInfo: _vm.getKngInfo, closePage: _vm.closeKngPage },
          }),
          _c(
            "yxt-drawer",
            {
              attrs: {
                title: _vm.$t("pc_biz_ote_btn_selectknglib") /** 选择知识 */,
                size: "960px",
                visible: _vm.openKngLibPage,
                "destroy-on-close": "",
                "before-close": _vm.closeKngLibPage,
              },
            },
            [
              _c("yxtbiz-select-newkng", {
                attrs: { max: 1, zip: false, isAi: true },
                model: {
                  value: _vm.kngLibsTemp,
                  callback: function ($$v) {
                    _vm.kngLibsTemp = $$v
                  },
                  expression: "kngLibsTemp",
                },
              }),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "yxt-button",
                    {
                      attrs: { plain: "" },
                      on: { click: _vm.closeKngLibPage },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("pc_biz_ote_btn_cancle") /** 取消 */)
                      ),
                    ]
                  ),
                  _c(
                    "yxt-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.getKngLibInfo },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("pc_biz_ote_btn_confirm") /** 确定 */)
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "yxtbiz-ai-create-ques__ques-panel" }, [
        _c(
          "div",
          { staticClass: "yxtbiz-ai-talking" },
          [
            _c(
              "yxt-scrollbar",
              { ref: "refTalk", attrs: { "fit-height": true } },
              [
                _vm.currentTalkInfo
                  ? _c(
                      "transition-group",
                      {
                        key: "talkInfos_" + _vm.askingId,
                        staticClass: "pt24 ph24 pb12",
                        attrs: { tag: "div", name: "yxt-fade-in-linear" },
                      },
                      [
                        _vm._l(_vm.currentTalkInfo, function (talk, index) {
                          return [
                            talk &&
                            (talk.msg || talk.allPoints) &&
                            talk.type === 12
                              ? _c(
                                  "div",
                                  {
                                    key: talk.msg + "_answer_" + index,
                                    staticClass:
                                      "yxtbiz-ai-talking__dialog yxtbiz-ai-talking__dialog--noavatar",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "yxtbiz-ai-talking__dialog-avatar",
                                      },
                                      [
                                        _c("yxt-svg", {
                                          attrs: {
                                            "remote-url": _vm.SvgMediaNewUrl,
                                            width: "28px",
                                            height: "28px",
                                            "icon-class": "ai-avatar",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "yxtbiz-ai-talking__dialog-content",
                                      },
                                      [
                                        _c("div", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.replaceTitlePrefix(talk.msg)
                                            ),
                                          },
                                        }),
                                        talk.ques
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mt16 flex flex-mid flex-between w-100",
                                              },
                                              [
                                                !talk.used
                                                  ? _c(
                                                      "yxt-button",
                                                      {
                                                        staticClass:
                                                          "yxtbiz-ai-talking__dialog-btn",
                                                        attrs: {
                                                          type: "text3",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.useQues(
                                                              talk
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex flex-mid color-primary-6",
                                                          },
                                                          [
                                                            _c("yxt-svg", {
                                                              staticClass:
                                                                "mr4",
                                                              attrs: {
                                                                "remote-url":
                                                                  _vm.SvgMediaNewUrl,
                                                                width: "16px",
                                                                height: "16px",
                                                                "icon-class":
                                                                  "ai-use-cc-s",
                                                              },
                                                            }),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "pc_biz_ote_lbl_quote"
                                                                  ) /** 引用 */
                                                                )
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex flex-mid",
                                                      },
                                                      [
                                                        _c("yxt-svg", {
                                                          staticClass: "mr4",
                                                          attrs: {
                                                            width: "16px",
                                                            height: "16px",
                                                            "icon-class":
                                                              "message-success",
                                                          },
                                                        }),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "pc_biz_ote_lbl_quoted"
                                                              ) /** 已引用 */
                                                            )
                                                          ),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        }),
                        _vm.asking
                          ? _c(
                              "div",
                              {
                                key: "ai-thinking",
                                staticClass:
                                  "yxtbiz-ai-talking__dialog yxtbiz-ai-talking__dialog--think yxtbiz-ai-talking__dialog--noavatar",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "yxtbiz-ai-talking__dialog-avatar",
                                  },
                                  [
                                    _c("yxt-svg", {
                                      attrs: {
                                        "remote-url": _vm.SvgMediaNewUrl,
                                        width: "28px",
                                        height: "28px",
                                        "icon-class": "ai-avatar",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "yxtbiz-ai-talking__dialog-content",
                                  },
                                  [
                                    _c("div", { staticClass: "flex" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "pc_biz_ote_btn_thinking"
                                            ) /** 正在思考 */
                                          ) +
                                          "\n                "
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ml8 yxtbiz-thinking-dot",
                                        },
                                        [_c("div"), _c("div"), _c("div")]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            key: "ai-result-tip",
                            staticClass:
                              "mt20 mb24 color-gray-7 standard-size-12",
                          },
                          [
                            _vm._v(
                              " \n            " +
                                _vm._s(
                                  _vm.asking
                                    ? _vm.$t("pc_biz_ote_msg_tiptag", [
                                        _vm.$t(
                                          "pc_biz_ote_msg_aiquesgentip" /** 注：在出题过程中关闭页面，也会进行相应题数的扣减，请避免在出题过程中关闭页面 */
                                        ),
                                      ])
                                    : _vm.$t(
                                        "pc_biz_ote_msg_instructionsforaiquestip" /** 注：受限于AI模型，偶有AI返回的数据不完整，请自行核对生成的试题是否正确 */
                                      )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex flex-center flex-mid pb24 pt12" },
          [
            _vm.asking
              ? _c(
                  "div",
                  {
                    staticClass: "yxtbiz-ai-talking__btns",
                    on: {
                      click: function ($event) {
                        return _vm.cancelAsk(true)
                      },
                    },
                  },
                  [
                    _c("yxt-svg", {
                      staticClass: "mr4",
                      attrs: {
                        "remote-url": _vm.SvgMediaNewUrl,
                        width: "16px",
                        height: "16px",
                        "icon-class": "ai-stop-cc",
                      },
                    }),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "pc_biz_ote_btn_stopgenerateques" /** 停止生成 */
                          )
                        ) +
                        "\n      "
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "yxtbiz-ai-talking__btns",
                    on: {
                      click: function ($event) {
                        return _vm.askAI(2, false, true)
                      },
                    },
                  },
                  [
                    _c("yxt-svg", {
                      staticClass: "mr4",
                      attrs: {
                        "remote-url": _vm.SvgMediaNewUrl,
                        width: "16px",
                        height: "16px",
                        "icon-class": "ai-continue1",
                      },
                    }),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "pc_biz_ote_btn_regenerateques" /** 重新生成 */
                          )
                        ) +
                        "\n      "
                    ),
                  ],
                  1
                ),
            !_vm.asking && _vm.askingType === 2
              ? _c(
                  "yxt-tooltip",
                  {
                    attrs: {
                      content: _vm.$t(
                        "pc_biz_ote_msg_backtoeditpoints" /** 修改出题知识点或内容 */
                      ),
                      placement: "top",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "yxtbiz-ai-talking__btns yxtbiz-ai-talking__btns--circle yxtbiz-ai-talking__btns--primary",
                        on: {
                          click: function ($event) {
                            return _vm.backAsk()
                          },
                        },
                      },
                      [
                        _c("yxt-svg", {
                          attrs: {
                            width: "18px",
                            height: "18px",
                            "icon-class": "edit",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }